import { Flex } from '@chakra-ui/react';
import { FormFeedback, OutlineCard, Select } from '@morressier/alembic';
import { IUser } from '@publishing-engine/domain/models';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';

export const Author = ({
  config,
  authorList,
  value
}: {
  config: FormFieldDefinition;
  authorList: IUser[];
  value: string;
}) => {
  const {
    setValue,
    formState: { errors }
  } = useFormContext();
  const {
    name,
    caseDataFields: { main: field },
    params: { validations, labels }
  } = config;

  const error = _.get(errors, field);

  return (
    <OutlineCard borderless padding={8} width="100%">
      <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
        <FieldLabel
          label={labels.main}
          subText={labels.subtitle}
          isRequired={validations.required}
        />
        <Select
          id={name}
          onChange={({ target: { value } }) => {
            setValue(field, JSON.parse(value));
          }}
          isInvalid={!!error}
          value={value || '{}'}
        >
          <option value="{}" disabled selected>
            Select a {labels.main}
          </option>
          {authorList.map(user => (
            <option key={user.id} value={JSON.stringify(user)}>
              {user.firstName} {user.lastName}
            </option>
          ))}
        </Select>
        {error && (
          <FormFeedback variant="error">
            Please select a {labels.main}
          </FormFeedback>
        )}
      </Flex>
    </OutlineCard>
  );
};
